import * as React from 'react'

import { Content } from '../../atoms/Content/index'
import { IntakeContainer } from '../../organisms/Intakes/IntakeContainer'
import { MenuPage } from '../MenuPage'
import { review2Steps } from '../../organisms/Intakes/review2Steps'

export class Review2Page extends MenuPage {
  public renderContent() {
    return (
      <Content>
        <IntakeContainer nextPage="/contents/30" steps={review2Steps} />
      </Content>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Review2Page/index.tsx